import { render, staticRenderFns } from "./ResourcePreview.vue?vue&type=template&id=26bd07ce&scoped=true&"
import script from "./ResourcePreview.vue?vue&type=script&lang=js&"
export * from "./ResourcePreview.vue?vue&type=script&lang=js&"
import style0 from "./ResourcePreview.vue?vue&type=style&index=0&id=26bd07ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bd07ce",
  null
  
)

export default component.exports